// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pc-0";
export var leftAlign = "_pc-4";
export var listItem = "_pc-2";
export var listItemWrapper = "_pc-1";
export var operationText = "_pc-3";